<template>
  <Teleport
    to="body"
  >
    <Transition
      name="update-notification"
      enter-active-class="transition-all duration-300 ease-out"
      enter-from-class="translate-y-full opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition-all duration-300 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-full opacity-0"
    >
      <div
        v-if="showUpdateNotification"
        class="fixed bottom-4 left-4 right-4 z-[9999] mx-auto max-w-sm md:left-auto md:max-w-md"
        role="alert"
        aria-live="polite"
      >
        <button
          class="absolute right-0 top-0 -m-1.5 inline-flex items-center border border-transparent text-slate-500 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 rounded transition-colors"
          @click="dismissUpdateNotification"
        >
          <fa
            icon="circle-xmark"
            size="xl"
          />
        </button>

        <div class="bg-white border border-gray-200 sol:rounded-xl rolfs:rounded-lg shadow-lg p-5 flex items-start gap-3">
          <fa
            icon="rotate-reverse"
            class="rolfs:text-primary -mr-0.5"
          />

          <div class="flex-1 min-w-0 -mt-1">
            <p class="font-semibold text-gray-900 mb-1">
              {{ $t('skew.title') }}
            </p>
            <p class="text-sm mb-0 font-secondary text-slate-500">
              {{ $t('skew.subtitle') }}
            </p>
          </div>

          <div class="flex gap-2 ml-3">
            <button
              class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors rolfs:font-secondary"
              @click="reloadToLatestDeployment"
            >
              {{ $t('skew.action') }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
const SKEW_CHECK_INTERVAL_MS = 45000

const showUpdateNotification = ref(false)

let scewCheckInterval: NodeJS.Timeout

const {
  checkForSkew,
  reloadToLatestDeployment,
} = useSkewProtection()

const dismissUpdateNotification = () => {
  showUpdateNotification.value = false
}

onMounted(() => {
  scewCheckInterval = setInterval(async () => {
    const isSkewed = await checkForSkew()
    if (isSkewed) {
      clearInterval(scewCheckInterval)
      showUpdateNotification.value = true
    }
  }, SKEW_CHECK_INTERVAL_MS)
})

onBeforeUnmount(() => {
  clearInterval(scewCheckInterval)
})
</script>

<style scoped>
.update-notification-enter-active,
.update-notification-leave-active {
  transition: all 0.3s ease;
}

.update-notification-enter-from {
  opacity: 0;
  transform: translateY(100%);
}

.update-notification-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
</style>
